import { tokens } from 'src/design-system';
import { buttonStyle, commonStyles, commonStyleSheet } from "src/Library/CommonStyles";

export const Form13Styles = (theme) => ({
  cancelButton: {
    ...buttonStyle('#424242', '#F2F4F6', '1px solid #DDE0E5'),
    fontSize: tokens.fontSize.h3,
    marginRight: `${tokens.spacing.sm}px`,
    padding: '0 28px',
  },
  nextButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    fontSize: tokens.fontSize.h3,
    padding: '0 28px',
  },
  requestDetailsMessage: {
    marginBottom: tokens.spacing.lg,
    color: '#666666',
    fontSize: tokens.fontSize.small,
    fontStyle: 'italic',
    fontWeight: tokens.fontWeight.semibold,
  },
  requestFormLabel: {
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
  },
  notAcceptiongRequestModal: {
    '& .ant-modal-body': {
      ...commonStyles(theme).flexColumn,
      borderRadius: '5px',
      color: '#424242',
      alignContent: 'space-between',
      fontWeight: tokens.fontWeight.semibold,
      textAlign: 'center',
    },
  },
  saveDraftButton: {
    fontSize: tokens.fontSize.small,
    borderColor: '#999999',
    height: 28,
    marginRight: tokens.spacing.sm,
  },
  submitButton: {
    marginRight: tokens.spacing.md,
    height: 28,
    borderRadius: tokens.radius.md,
    fontSize: tokens.fontSize.small,
    backgroundColor: `${tokens.colors.primaryDark} !important`,
    border: `1px solid ${tokens.colors.primaryDark}`,
  },
  main: {
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    '& .ant-drawer-header': {
      padding: tokens.spacing.ms,
      position: 'absolute',
      zIndex: 10,
      width: '100%',
    },
    '& .ant-drawer-body': {
      marginTop: 56,
      padding: 0,
      backgroundColor: '#F1EEE7',
    },
    marginBottom: 100,
  },
  header: {
    ...commonStyleSheet.flexRow,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.h1,
    color: '#000000',
    height: 32,
  },
  box: {
    ...commonStyleSheet.flexRow,
    marginBottom: tokens.radius.md,
    padding: 20,
    alignItems: 'normal',
    boxSizing: 'border-box',
    border: '1px solid #F7F7F7',
    borderRadius: tokens.radius.md,
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    backgroundColor: tokens.colors.bgWhite,
  },
  boxIcon: {
    width: '20%',
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
  },
  contentHeading: {
    fontSize: tokens.fontSize.h3,
    color: '#424242',
    fontWeight: 'bold',
  },
  selectField: {
    width: '100%',
    '& .ant-select-selection__placeholder, .ant-select-search__field__placeholder': {
      fontSize: tokens.fontSize.small,
    },
    '& .ant-select-selection-selected-value': {
      fontSize: tokens.fontSize.small,
    },
  },
  label: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '9px',
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  textAreaField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  inputNumberField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  inputField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  flexColumn: {
    ...commonStyles(theme).flexColumn,
  },
  textAreaLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  addMore: {
    cursor: 'pointer',
    color: tokens.colors.primary,
  },
  documentSubHeading: {
    color: '#262626',
    fontSize: tokens.fontSize.small,
    paddingRight: tokens.spacing.ms,
  },
  documentHeading: {
    fontWeight: 'bold',
    padding: '0 0 7.5px 8.5px',
    borderBottom: '1px solid #D9D9D9',
    marginBottom: tokens.spacing.lg,
    color: '#424242',
  },
  documentLabel: {
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.body,
  },
  referenceNumDiv: {
    borderRadius: '18px',
    backgroundColor:'rgba(23,162,178,0.05)',
    margin:`${tokens.spacing.lg}px ${tokens.spacing.lg}px 0px 0px`,
  },
  referenceNumContent: {
    color: '#262626',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    padding: `${tokens.spacing.sm}px 14px 6px 15px`
  },
  alignitemsBaseLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  containerWiseStatus: {
    padding:`${tokens.spacing.xs}px 5px`,
    borderRadius:'14px',
    marginLeft:tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  hazDetailsHeading:{
    padding: '0 0 7.5px 0.5px',
    marginBottom:'15.5px',
    fontSize: tokens.fontSize.small,
    fontWeight: 'bold',
    color: '#262626',
    borderBottom: '1px solid #D9D9D9'
  },
  additionalHazFieldName: {
    fontSize: tokens.fontSize.small,
    color:'#303030',
    marginBottom:'15.5px',
    ...commonStyles(theme).flexRow
  },
  additionalHazFieldValue: {
    fontSize: tokens.fontSize.body,
    color:'#303030',
    fontWeight: tokens.fontWeight.semibold,
    marginBottom:tokens.spacing.md,
    ...commonStyles(theme).flexRow,
  },
  additionalHeading: {
    fontSize: tokens.fontSize.body,
    lineHeight:'16px',
    fontWeight:'bold',
    color: tokens.colors.textSecondary,
    marginBottom: tokens.spacing.lg,
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  containerDiv: {
    margin: `0 ${tokens.spacing.md}px 0 36px`,
    borderBottom: '1px solid rgba(0,0,0,0.15)',
    padding: `${tokens.spacing.lg}px 0 0 0`,
  },
  addContainerButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.small,
    padding: '0 15px',
  },
  contentLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  collapse: {
    borderBottom: '1px solid rgba(0,0,0,0.15)',
    border: 0,
    borderRadius: 0,
    marginLeft: '10px',
    '& .ant-collapse-content': {
      backgroundColor: 'unset',
    },
  },
  justifySpaceBetween: {
    ...commonStyles(theme).justifySpaceBetween,
  },
  retryError: {
    fontSize: tokens.fontSize.body,
    color: '#0780FE',
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
});
